import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-085e51ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { id: "nav" }
const _hoisted_3 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { isLoggedIn: _ctx.isLoggedIn }, null, 8, ["isLoggedIn"])
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_router_view, {
        userInfo: _ctx.userInfo,
        connString: _ctx.connString,
        translate: _ctx.translate,
        onUpdateUserInfo: _cache[0] || (_cache[0] = ($event: any) => (_ctx.userInfo = $event))
      }, null, 8, ["userInfo", "connString", "translate"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Footer)
    ])
  ]))
}